import React from 'react';
import { WMICMasterInput } from 'wmic-pe-components-platform-react';
import styles from './WMICLookupField.module.scss';

const WMICLookupField = props => (
    <WMICMasterInput
        {...props}
        controlType="typeahead"
        internalClassNames={{
            value: styles.wmicMultiLineLookupFieldValue,
            option: styles.wmicMultiLineLookupFieldOption,
            title: styles.wmicMultiLineLookupFieldTitle,
        }}
    />
);

export default WMICLookupField;
